import React from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon';
import {str2class, addDecimals, toggleTooltip} from '../lib/utils';
import styled from 'styled-components';

const StyledProduct = styled.div`
  background: #fff;
  margin: 1%;
  width: 98%;
  display: inline-block;
  border-radius: 8px;
  box-shadow: 2px 2px 8px 2px rgba(0, 0, 0, .1);
  height: 320px;
  overflow: hidden;
  -webkit-transition: box-shadow .2s ease-in-out;
  -moz-transition: box-shadow .2s ease-in-out;
  -o-transition: box-shadow .2s ease-in-out;
  transition: box-shadow .2s ease-in-out;
  &:hover {
    box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, .25);
  }

  @media (min-width: 640px) {
    width: 48%;
  }
  @media (min-width: 1280px) {
    width: 31.333333%;
  }
  @media (min-width: 1600px) {
    width: 23%;
  }
  > div:first-child {
    height: 64px;
    background-color: #FFF;
    border-radius: 8px 8px 0 0;
    box-shadow: 0 0 10px 0 rgba(0,0,0,.25);
    display: flex;
    position: relative;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    overflow: hidden;
    input[type="checkbox"] {
      position: relative;
      z-index: 3;
      display:none;
      + label::before {
        cursor: pointer;
        position: relative;
        width: 14px;
        height: 14px;
        background-color: #EEE;
        display: inline-block;
        content: "";
        margin: 0 16px;
        top: 2px;
        border-radius: 7px;
        z-index: 2;
        border: 2px solid #EEE;
      	-webkit-transition: all .2s ease-in-out;
      	-moz-transition: all .2s ease-in-out;
      	-o-transition: all .2s ease-in-out;
      	transition: all .2s ease-in-out;
      }
      &:checked {
        + label::before {
          border: 2px solid #EEE;
          background-color: #333;
        }
      }
    }
    label {
      position: relative;
      z-index: 2;
      cursor: pointer;
      font-size: 0.825em;
      padding-bottom: 2px;
      > a {
        text-decoration: none;
        color: #333;
        display: inline-block;
      	-webkit-transition: all .2s ease-in-out;
      	-moz-transition: all .2s ease-in-out;
      	-o-transition: all .2s ease-in-out;
      	transition: all .2s ease-in-out;
        &:hover {
          color: #21A0D2;
        }
      }
    }
    &::before {
      display: block;
      content: "";
      position: absolute;
      z-index: 1;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
  }
  .props {
    .contain {
      height: 256px;
      overflow: auto;
      background-color: #F6F6F6;
      border-radius: 0 0 8px 8px;
      &::-webkit-scrollbar {
        width: 6px;
      }
      &::-webkit-scrollbar-track {
        background-color: #EEE;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #21A0D2;
        border: 2px solid #EEE;
      }
    }

    svg {
      fill: #666;
      stroke: #666;
    }
    ul {
      padding: 0;
      margin: 15px 0 15px;
      > li {
        padding: 0 20px;
        cursor: pointer;
        &:hover,
        &.active {
          background: #e2e2e2;
        }
        > div {
          padding: 10px 0;
          display: table;
          width: 100%;
          i {
            display: table-cell;
            vertical-align: middle;
            svg {
              width: 14px;
              height: 14px;
            }
          }
          > span {
            color: #333;
            margin-left: 44px;
            text-transform: uppercase;
            display: table-cell;
            padding: 0;
            font-size: .75em;
            padding-left: 40px;
            width: 50%;
            vertical-align: middle;
            &:last-child {
              font-size: .825em;
              text-transform: none;
              color: #666;
            }
          }
        }
      }
    }

    /* div > div:last-child{
      text-align: center;
    }
    div > span:first-child {
      margin-right: 10px;
      fill: #aaa;
      stroke: #aaa;
    } */
  }
`;

export default function ProductCard (props) {
  const {data, toggle, selected, setCompareProp, compareProp} = props;
  const {id, name, url, properties, track} = data || {};
  return (
    <StyledProduct props={props}>
      <div>
        <input type="checkbox" id={id} value={id}  onChange={() => toggle(id)} checked={selected}/>
        <label htmlFor={id}><a href={url} target="_blank" rel="noopener noreferrer" onClick={track}>{name}</a></label>
      </div>
      <div className="props">
        <div className="contain">
          <ul>
          {properties.filter(prop => !!prop.value && prop.value !== -1).map((item, index) =>
            <li key={index} onClick={() => setCompareProp(item.label)} className={compareProp === item.label ? "active" : null}>
              <div>
                <Icon name={str2class(item.label)}/>
                <span
                  onMouseOver={(e) => {toggleTooltip(e, item)}}
                  onMouseOut={(e) => {toggleTooltip()}}
                >{item.label}</span>
                <span>{item.type === "sensory" ? item.classified : addDecimals(item)} {!!item.unit && item.unit}</span>
              </div>
            </li>
          )}
          </ul>
        </div>
      </div>
    </StyledProduct>
  )
}

ProductCard.propTypes = {
  data: PropTypes.object,
  compareProp: PropTypes.string,
  toggleCompareProp: PropTypes.func,
};
